<template>
  <div>
    <v-select
      v-model="currentDomains"
      :items="currentUser.domains"
      :menu-props="{ maxHeight: '400' }"
      :ripple="false"
      class="domainSelect"
      label="All domains"
      multiple
      hideDetails
      return-object
      append-icon="mdi-chevron-down"
      solo
      flat
      item-text="domain"
      item-value="id"
    >
      <template #selection="{ item, index }">
        <span v-if="index === 0">{{ item.domain }}</span>
        <span v-if="index === 1" class="ml-2 grey--text caption">
          (+{{ currentDomains.length - 1 }} others)
        </span>
      </template>
      <template #prepend-item>
        <v-list-item :ripple="false" @click="selectAllDomains">
          <v-list-item-action>
            <v-icon>
              {{ icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Select All</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DomainsSelect",
  computed: {
    ...mapGetters(["currentUser", "selectedDomains", "cookeSelectedDomains"]),
    icon() {
      if (
        (this.selectedDomains &&
          this.currentUser.domains &&
          this.selectedDomains.length === this.currentUser.domains.length) ||
        !this.selectedDomains ||
        !this.currentUser.domains ||
        this.selectedDomains.length === 0
      ) {
        return "mdi-checkbox-marked";
      }
      if (
        this.selectedDomains &&
        this.currentUser.domains &&
        this.selectedDomains.length !== 0 &&
        this.currentUser.domains !== 0 &&
        this.selectedDomains.length !== this.currentUser.domains.length
      ) {
        return "mdi-minus-box";
      }
      return "mdi-checkbox-blank-outline";
    },
    currentDomains: {
      get() {
        if (this.cookeSelectedDomains) {
          return this.cookeSelectedDomains;
        }
        if (!this.selectedDomains) {
          return [];
        }
        if (!this.currentUser.domains) {
          return [];
        }
        if (this.selectedDomains.length === this.currentUser.domains.length) {
          return [];
        }
        return this.selectedDomains;
      },
      set(val) {
        //if (this.selectedDomains.length === 1 && val.length === 0) {
        if (val.length === 0) {
          this.$store.commit("setSelectedDomains", this.currentUser.domains);
        } else {
          this.$store.commit("setSelectedDomains", val);
        }
      }
    }
  },
  methods: {
    selectAllDomains() {
      this.$store.commit(
        "setSelectedDomains",
        this.currentUser.domains ? this.currentUser.domains : []
      );
    }
  }
};
</script>
<style lang="scss">
.domainSelect {
  .v-input__control {
    box-shadow: 0px 0px 3px rgba(54, 78, 101, 0.08);
  }
  .v-input__control:hover {
    box-shadow: 0px 1px 8px rgba(54, 78, 101, 0.1);
  }
  .v-input__slot {
    height: 56px !important;
  }
  span,
  label {
    margin-left: 16px;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0.02em;
    color: #273852 !important;
    top: 6px !important;
  }
  .v-input__icon--append {
    margin: 10px;
    min-width: auto !important;
    min-height: auto !important;
    width: auto !important;
    height: auto !important;
  }
}
</style>
<style scoped>
.v-input {
  box-shadow: none;
  border-radius: 32px;
}
</style>
